import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import Button from 'components/Button'
import { NotifyProsOfUnclaimedJobsViewModel } from './NotifyProsOfUnclaimedJobsViewModel'

interface NotifyProsOfUnclaimedJobsDialogProps {
  vm: NotifyProsOfUnclaimedJobsViewModel
}

export default observer(function NotifyProsOfUnclaimedJobsDialog({
  vm,
}: NotifyProsOfUnclaimedJobsDialogProps) {
  return (
    <ModalSheet onRequestClose={vm.close} showing={vm.showing}>
      <ModalSheetHeader withCloseButton />

      <ModalSheetContentIllustration
        src={require('assets/images/img_chat.svg')}
        alt="Illustration of a hand holding a phone and reading a message"
      />

      <ModalSheetContent>
        <ModalSheetContentTitle>
          Notify Pros of unclaimed jobs
        </ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Do you want to notify all available Pros of unclaimed jobs in this
          workspace?
        </ModalSheetContentDescription>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
          <Button
            type="primary"
            onClick={vm.notifyPros}
            loading={vm.notifyPros.pending}
            data-test="notify-pros-of-unclaimed-jobs-button"
          >
            Notify Pros
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
